export default (arrayOfObjects, objectKey, objectValue) => {
  let findItem = false;
  arrayOfObjects.forEach((item) => {
    if (item[objectKey] === objectValue) {
      findItem = item;
    }
  });
  return findItem;
};
